import type { GeneratedLesson } from "../types";
import { Package } from "lucide-react";

interface MaterialsSectionProps {
  lesson: GeneratedLesson;
}

export function MaterialsSection({ lesson }: MaterialsSectionProps) {
  if (!lesson.materials || lesson.materials.length === 0) {
    return null;
  }

  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Package
          className="w-5 h-5"
          style={{ color: "var(--primary-color)" }}
        />
        <h3
          className="text-xl font-bold"
          style={{ color: "var(--text-primary)" }}
        >
          Materiais Necessários
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {lesson.materials.map((material, idx) => (
          <div
            key={idx}
            className="p-3 border rounded-lg flex items-start gap-3"
            style={{ borderColor: "var(--border-color)" }}
          >
            <span
              className="shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-xs"
              style={{
                backgroundColor: "var(--primary-color)",
                color: "white",
              }}
            >
              ✓
            </span>
            <span style={{ color: "var(--text-primary)" }}>{material}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
